// Merchant web entry. Wires the design-tokens + Tailwind 4 stylesheet,
// mounts the React tree, and stamps a marker for E2E tests.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles/globals.css";

import { App } from "@/App";
import { env } from "@/env";

document.documentElement.dataset.app = "web-merchant";
document.documentElement.dataset.theme = "merchant";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("[web-merchant] #root element not found in index.html");
}

// eslint-disable-next-line no-console
console.info(
  `[web-merchant] booting v${env.appName} → API ${env.apiBaseUrl}`,
);

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
